export default "<router-outlet></router-outlet>\r\n<app-loading-screen></app-loading-screen>"